import React from "react";
import "./ServicesContactCard.css";

const ServicesContactCard = () => {
  return (
    <section className="ServicesContactCard-container">
      <div className="container">
        <div className="row text-center">
          <div className="col-md-4">
            <div className="ServicesContactCard-infoBox">
              <h2 className="ServicesContactCard-number">150+</h2>
              <p className="ServicesContactCard-text">
                Home Health Care Professionals
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="ServicesContactCard-infoBox">
              <h2 className="ServicesContactCard-number">99%</h2>
              <p className="ServicesContactCard-text">
                Our Client Satisfaction Rate
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="ServicesContactCard-infoBox">
              <h2 className="ServicesContactCard-number">2+</h2>
              <p className="ServicesContactCard-text">Office Locations</p>
            </div>
          </div>
        </div>
      </div>
      <div className="ServicesContactCard-contactBox">
        <h6 className="ServicesContactCard-callText">CALL US NOW</h6>
        <h2 className="ServicesContactCard-question">
          Have Any Question? Ask Us Anything, <br /> We’d Love To Answer!
        </h2>
        <div className="ServicesContactCard-phone">
          <i className="bi bi-telephone-fill"></i>
          <span className="ServicesContactCard-phoneNumber">
            <a
              href="tel:+919840562357"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              +91 98400 88046
            </a>
          </span>
        </div>
      </div>
    </section>
  );
};

export default ServicesContactCard;
